import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/ilustrations/pwa.gif'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "256",
  width: "256"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "content" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Sua lista sempre com você"),
  /*#__PURE__*/_createElementVNode("p", null, "Você pode adicionar a sua lista de compras à tela inicial do seu dispositivo facilmente, ganhando acesso instantâneo ao aplicativo, sem precisar digitar a URL ou abrir o navegador."),
  /*#__PURE__*/_createElementVNode("p", null, "Além de facilitar o acesso ao aplicativo, você pode colocá-lo em um local especial para sempre lembrar de conferir a sua lista antes de sair para o mercado!")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("article", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_Button, {
      disabled: _ctx.disableButton,
      "button-text": 'Adicionar à tela inicial',
      "has-icon": 'No',
      onClick: _ctx.handleInstallation
    }, null, 8, ["disabled", "onClick"])
  ]))
}